const $ = jQuery;
const $window = $(window);

const initSlider = () => {
  const els = once('gallery-image-slider', '.p-image-slider');
  els.forEach((el) => {
    const $wrapper = $(el);
    // this slider is *usually* added with Static: HTML paragraph
    const $slider = $wrapper.find('.pis-slider');

    // Slick initialization
    $slider.slick({
      slidesToShow: $slider.children().length - 1,
      centerMode: true,
      centerPadding: '0px',
      variableWidth: true,
      dots: true,
      autoplay: true,
      accessibility: true,
      pauseOnHover: true,
      autoplaySpeed: 3000,
      prevArrow: $wrapper.find('.om-slider-arrow-prev'),
      nextArrow: $wrapper.find('.om-slider-arrow-next'),
      appendDots: $wrapper.find('.om-slider-dots'),
      responsive: [
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: false,
          },
        },
      ],
    });
  });
};

// @todo should all these calls be in single call
$window.on('load', function () {
  initSlider();
});
